export default [
  {
    name: 'name',
    type: 'text',
    value: '',
    validation: 'required',
    tableDisplay: true,
    allowEdit: true,
    icon: 'domain',
  },
  {
    name: 'image',
    type: 'text',
    value: '',
    validation: 'required',
    tableDisplay: true,
    allowEdit: true,
    icon: 'image',
  },
  {
    name: 'url',
    type: 'text',
    value: '',
    validation: '',
    tableDisplay: true,
    allowEdit: true,
    icon: 'insert_link',
  },
]
